import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useDeleteAuthorMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (id: number) => Api.authors.deleteAuthor(project, id),
  });
}
